import { c as _c } from "react/compiler-runtime";
import { PaymentMethodEnum } from '@systemeio/types';
import { useFunnelStepData } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/hooks/use-funnel-step-data';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';

/**
 * A bump is available only while the plan quota is not spent and the user can accept payments.
 * The quota is shared by every offer step, so the mutator is exposed to refetch it after a change.
 *
 * `disabledReason` is set only when the reason is actually known: while the quota is still loading
 * the bump cannot be added yet, but claiming the plan limit was reached would be a lie.
 */
export function useOrderBumpAvailability(paymentMethods) {
  const $ = _c(11);
  const {
    t
  } = useLocoTranslation();
  const {
    funnelStepData,
    mutateFunnelStepData
  } = useFunnelStepData();
  const hasAvailableBumps = !!funnelStepData && funnelStepData.bumpsCount > 0;
  const hasPaymentMethods = paymentMethods.length > 0;
  let t0;
  if ($[0] !== funnelStepData || $[1] !== hasAvailableBumps || $[2] !== hasPaymentMethods || $[3] !== t) {
    t0 = () => {
      if (!funnelStepData) {
        return;
      }
      if (!hasAvailableBumps) {
        return t("dashboard.funnel.configuration.offer.order_bump_limit_description");
      }
      if (!hasPaymentMethods) {
        return <>{t("dashboard.funnel.configuration.offer.need_payment_methods_description")}<br /><LinkWithoutPrefetch target="_blank" className="link inline-block w-fit max-w-full" href="/profile/payment-gateways">{t("dashboard.funnel.configuration.offer.go_to_payment_gateway_link_description")}</LinkWithoutPrefetch></>;
      }
    };
    $[0] = funnelStepData;
    $[1] = hasAvailableBumps;
    $[2] = hasPaymentMethods;
    $[3] = t;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const getDisabledReason = t0;
  const t1 = hasAvailableBumps && hasPaymentMethods;
  let t2;
  if ($[5] !== getDisabledReason) {
    t2 = getDisabledReason();
    $[5] = getDisabledReason;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== mutateFunnelStepData || $[8] !== t1 || $[9] !== t2) {
    t3 = {
      canAddBump: t1,
      disabledReason: t2,
      mutateFunnelStepData
    };
    $[7] = mutateFunnelStepData;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}